import React from 'react';

type ExpansionButtonProps = {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  expandText: string;
  collapseText: string;
  count?: number;
};

export default function ExpansionButton({
  isExpanded,
  setIsExpanded,
  expandText,
  collapseText,
  count,
}: ExpansionButtonProps) {
  return (
    <button
      onClick={() => setIsExpanded(!isExpanded)}
      className="w-full flex justify-center items-center px-4 py-2 hover:bg-gray-100 text-sm text-blue-600 border border-blue-600 rounded-md transition-colors mt-4"
    >
      {isExpanded ? (
        <>
          <svg className="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
          {collapseText}
        </>
      ) : (
        <>
          <svg className="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
          {expandText} {count !== undefined && count > 0 ? `(${count})` : ''}
        </>
      )}
    </button>
  );
}
